module.exports = __webpack_public_path__ + "img/logo-blanc.6db558ac.svg";